import { ContentPlacement } from '@candu-ai/placement/types';
import { Snapshot } from '@candu-ai/snapshots/types';

import { SET_SNAPSHOT, SET_SNAPSHOT_LOADED } from './constants';

export const setSnapshot = (snapshot?: Snapshot, placement?: ContentPlacement) => {
  return {
    type: SET_SNAPSHOT,
    snapshot,
    placement,
  };
};

export const setSnapshotState = (isLoaded: boolean) => {
  return {
    type: SET_SNAPSHOT_LOADED,
    isLoaded,
  };
};
